import {Session} from "../../../../types";
import {EditSessionButton} from "./EditSessionButton";
import {DeleteSessionButton} from "./DeleteSessionButton";
import {Play, ChevronDown, ChevronUp} from "lucide-react";
import React, { useState } from "react";
import {useNavigate} from "react-router-dom";
import { SessionRunsList } from "./SessionRunsList";

interface Props {
    session: Session;
    onDelete: () => void;
}

export function SessionRow({ session, onDelete }: Props) {
    const navigate = useNavigate();
    const [isExpanded, setIsExpanded] = useState(false);

    const handleRowClick = () => {
        setIsExpanded(!isExpanded);
    };

    const handleButtonClick = (e: React.MouseEvent, action: () => void) => {
        e.stopPropagation();
        action();
    };

    return (
        <div className="border-b border-gray-200 last:border-b-0">
            <div
                className="p-4 hover:bg-gray-50 transition-colors cursor-pointer"
                onClick={handleRowClick}
            >
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3 flex-1">
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                setIsExpanded(!isExpanded);
                            }}
                            className="p-1 hover:bg-gray-200 rounded transition-colors"
                        >
                            {isExpanded ? (
                                <ChevronUp className="h-5 w-5 text-gray-600" />
                            ) : (
                                <ChevronDown className="h-5 w-5 text-gray-600" />
                            )}
                        </button>
                        <div>
                            <h3 className="text-lg font-semibold text-gray-900">{session.name}</h3>
                        </div>
                    </div>
                    <div className="flex items-center space-x-2">
                        <EditSessionButton session={session} />
                        <DeleteSessionButton session={session} onDelete={onDelete} />

                        <button
                            onClick={(e) => handleButtonClick(e, () => navigate(`/panel/sessions/${session.uuid}`))}
                            className="flex items-center px-4 py-2 bg-indigo-100 text-indigo-700 rounded-lg hover:bg-indigo-200 transition-colors"
                        >
                            <Play className="h-4 w-4 mr-2" />
                            Join
                        </button>
                    </div>
                </div>
            </div>

            {isExpanded && (
                <div className="px-4 pb-4 bg-white">
                    <div className="pl-10">
                        <SessionRunsList sessionUuid={session.uuid} />
                    </div>
                </div>
            )}
        </div>
    );
}
